import React, { useState } from "react";
import { DialogBox } from "../../../../components/Elements/DialogBox";
import { Select } from "antd";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";

const FilterLocationDeparment = ({
  onOpen,
  onClose,
  onApply,
  currentStatus,
}) => {
  const [status, setStatus] = useState(currentStatus || null);

  const statusOptions = [
    { label: "All", value: "All" },
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];

  return (
    <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
      {/* Heading */}
      <div>
        <h3 className="text-xl font-semibold">Filter</h3>
      </div>

      {/* Status Dropdown */}
      <div className="flex flex-col w-full mt-8">
        <Select
          showSearch
          optionFilterProp="children"
          value={status}
          onChange={(val) => {
            setStatus(val);
          }}
          placeholder="SELECT STATUS"
          className="text-lg font-light h-14"
          allowClear
        >
          {statusOptions.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </div>

      {/* Buttons */}
      <div className="flex justify-center gap-4 py-6">
        <CustomButton
          buttonType="primary"
          variant="cancel"
          buttonText="Reset"
          className="text-sm px-6 py-2 rounded-lg"
          onClick={() => {
            // clear selection and notify parent; keep dialog open
            setStatus(null);
            onApply(undefined);
          }}
        />

        <CustomButton
          buttonType="primary"
          variant="ok"
          buttonText="Search"
          className="text-sm px-6 py-2 rounded-lg"
          onClick={() => {
            onApply(status);
            onClose();
          }}
        />
      </div>
    </DialogBox>
  );
};

export default FilterLocationDeparment;
